<template>
  <div class="result_box">
    <!-- <div class="view flex_c" v-if="quesRes == 'success'"> -->
      <div class="result-mod suc-mod" v-if="quesRes == 'success'">
        <div>
          <img src="@/assets/suc-img.png" />
        </div>
        <h2>闯关成功</h2>
        <p>获得一次点亮星星的机会</p>
        <a @click="hasSignup">
          点亮星星
        </a>
        <router-link to="/">
          返回首页
        </router-link>
      <!-- </div> -->
    </div>
    <!-- <div class="view flex_c" v-if="quesRes == 'error'"> -->
      <div class="result-mod suc-mod" v-if="quesRes == 'error'">
        <div>
          <img src="@/assets/fail-img.png" />
        </div>
        <h2>闯关失败</h2>
        <router-link to="/game?again=1">
          再来一次
        </router-link>
        <router-link to="/">
          返回首页
        </router-link>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import index from "./index.js";

export default {
  ...index
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
